import setBposNavBarData from '../mutators/setBposNavBarData';
import getBposNavBarDataService from '../services/getBposNavBarDataService';
import { action, orchestrator } from 'satcheljs';
import { isConsumer } from 'owa-session-store';

const loadBposNavBarData = action('LOAD_BposNavBarData');
export default loadBposNavBarData;

orchestrator(loadBposNavBarData, actionMessage => {
    if (!isConsumer()) {
        getBposNavBarDataService().then(bposNavBarData => {
            setBposNavBarData(bposNavBarData);
        });
    }
});
